<template>
  <v-card
    class="card"
    :flat="flat"
  >
    <slot />
  </v-card>
</template>

<script>
export default {
  props: {
    flat: {
      type: Boolean,
      default: true,
    },
  },
};
</script>


<style lang="scss" scoped>
.card {
  border-radius: 10px;
  padding-bottom: 10px;
}
</style>
